/* AppsGrid.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu85zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2d3pA%7Bgrid-template-columns%3Arepeat(auto-fit%2Cminmax(252px%2C1fr))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aNu0LYbGa%7Blist-style-type%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2zezl%7Bgrid-template-columns%3Arepeat(auto-fill%2Cminmax(252px%2C1fr))%7D");
import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Grid as LegacyGrid } from '@atlaskit/primitives/grid';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { fg } from '@townsquare/stat-sig/gate';
const fillResponsiveGridStyles = xcss({
  gridTemplateColumns: 'repeat(auto-fit, minmax(252px, 1fr))',
  gap: 'space.200',
  // Cancel out ul styles
  listStyleType: 'none',
  paddingInlineStart: 'space.0',
  marginBlockStart: 'space.0'
});
const responsiveGridStyles = xcss({
  gridTemplateColumns: 'repeat(auto-fill, minmax(252px, 1fr))',
  gap: 'space.200',
  // Cancel out ul styles
  listStyleType: 'none',
  paddingInlineStart: 'space.0',
  marginBlockStart: 'space.0'
});
const styles = {
  fillResponsiveGrid: "_2mHwu85zaO _2iEGP2d3pA _0aNu0LYbGa _0LQT5EPgdg _43nrzTPgdg",
  responsiveGrid: "_2mHwu85zaO _2iEGP2zezl _0aNu0LYbGa _0LQT5EPgdg _43nrzTPgdg"
};
interface Props {
  children: React.ReactNode;
  fillAvailableSpace?: boolean;
}
export const AppsGrid = ({
  children,
  fillAvailableSpace = false
}: Props): React.JSX.Element => fg('townsquare-compiled-xcss-to-cssmap-final') ? <Grid xcss={fillAvailableSpace ? styles.fillResponsiveGrid : styles.responsiveGrid} as="ul">
			{children}
		</Grid> : <LegacyGrid xcss={fillAvailableSpace ? fillResponsiveGridStyles : responsiveGridStyles} as="ul">
			{children}
		</LegacyGrid>;